import React, { useCallback, useMemo } from 'react'
import { useDevice } from 'device'

import { useCatalogueProducts } from 'modules/products'

import { ProductsFeedPage } from 'typings/graphql'

import InfinityScrollProductFeed from 'compositions/InfinityScrollProductFeed/InfinityScrollProductFeed'


export type ProductFeedProps = {
  feedName: ProductsFeedPage
  catalogueId: number
  limit?: number
}

const metadata = {
  placement: 'Feed',
}


const ProductFeed: React.FunctionComponent<ProductFeedProps> = (props) => {
  const { catalogueId, limit, feedName } = props
  const { isMobile } = useDevice()

  const productsLimit = limit || (isMobile ? 12 : 6)

  const variables = useMemo<ProductsModule.UseCatalogueProductsProps['variables']>(() => ({
    id: catalogueId,
    input: {
      limit: productsLimit,
      offset: 0,
      filter: null,
      productsFeed: feedName,
    },
    withCount: true,
    withRetailPrice: false,
  }), [ feedName, catalogueId, productsLimit ])

  const { data, isFetching, fetchMore } = useCatalogueProducts({
    variables,
    ssr: false,
    notifyOnNetworkStatusChange: true,
    skip: !catalogueId,
  })

  const handleFetchMore = useCallback(() => {
    // TODO: add analytics for PLP added on 29–05–2022 by algeas
    fetchMore({
      variables: {
        ...variables,
        input: {
          ...variables.input,
          offset: data?.products?.length,
        },
      },
    })
  }, [ data?.products?.length, fetchMore, variables ])

  const visibleProductsAmount = data?.products?.length || 0

  const totalCount = data?.count || 0
  const restProductsAmount = totalCount - visibleProductsAmount
  const fetchMoreSkeletonsAmount = restProductsAmount > limit ? limit : restProductsAmount

  return (
    <InfinityScrollProductFeed
      className="mt-24"
      products={data?.products}
      metadata={metadata}
      fetchMore={handleFetchMore}
      fetchSkeletonsAmount={fetchMoreSkeletonsAmount}
      isFetching={isFetching}
      totalCount={totalCount}
      // TODO: Delete when all originally added products lose the status of new added on 09–06–2022 bu algeas
      excludeMarketingLabel="NEW_ARRIVAL"
      withoutNotes
      isEcommerce
    />
  )
}


export default ProductFeed
